import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useResponsive } from '../../contexts/ResponsiveContext';

interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface AutomotiveBreadcrumbsProps {
    items: BreadcrumbItem[];
    onBreadcrumbClick: (index: number) => void;
}

function handleClick(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    index: number,
    onBreadcrumbClick: (index: number) => void
) {
    event.preventDefault();
    onBreadcrumbClick(index);
}

const AutomotiveBreadcrumbs: React.FC<AutomotiveBreadcrumbsProps> = ({
    items,
    onBreadcrumbClick,
}) => {
    const { isScreenMd, isScreenSm, isScreenXs } = useResponsive();

    const breadcrumbs = items.map((item, index) => (
        <Link
            underline="hover"
            key={index}
            href={item.href}
            onClick={(event) => handleClick(event, index, onBreadcrumbClick)}
            sx={{
                cursor: 'pointer',
                '&:hover': {
                    textDecorationColor:
                        index === items.length - 1 && index !== 0 ? '#E5673E' : 'black',
                },
            }}
        >
            <Typography
                sx={{
                    width: '100%',
                    fontFamily: 'Poppins',
                    fontWeight: isScreenMd || isScreenSm || isScreenXs ? 700 : 700,
                    fontSize: isScreenMd || isScreenSm || isScreenXs ? '16px' : '24px',
                    color:
                        items.length === 1
                            ? 'black'
                            : index === items.length - 1
                              ? '#E5673E'
                              : 'black',
                }}
            >
                {item.label === 'computing-enterprisesystems' ? 'Computing' : item.label}
            </Typography>
        </Link>
    ));

    return (
        <Breadcrumbs
            separator={items.length > 1 ? <NavigateNextIcon fontSize="small" /> : ''}
            aria-label="breadcrumb"
        >
            {breadcrumbs}
        </Breadcrumbs>
    );
};

export default AutomotiveBreadcrumbs;
